import {DotLottieReact} from '@lottiefiles/dotlottie-react'

import spinnerLottie from '@/assets/lotties/spinner.lottie'
import style from '@/views/Stores/StoreFront.module.scss'

interface StoreHeroProps {
  title: string
  bannerSrc?: string
  bannerMobileSrc?: string
}

export default function StoreHero({title, bannerSrc, bannerMobileSrc}: StoreHeroProps) {
  const [currentBanner, setCurrentBanner] = useState<string | undefined>()
  const [isLoading, setIsLoading] = useState(true)

  const getCurrentBanner = useCallback(() => {
    return window.innerWidth <= 767
      ? (bannerMobileSrc ?? bannerSrc)
      : (bannerSrc ?? bannerMobileSrc)
  }, [bannerSrc, bannerMobileSrc])

  useEffect(() => {
    const updateBanner = () => {
      const newBanner = getCurrentBanner()
      if (newBanner !== currentBanner) {
        setCurrentBanner(newBanner)
        setIsLoading(true)
      }
    }

    updateBanner()

    window.addEventListener('resize', updateBanner)
    return () => {
      window.removeEventListener('resize', updateBanner)
    }
  }, [getCurrentBanner, currentBanner])

  useEffect(() => {
    if (!currentBanner) {
      setIsLoading(false)
      return
    }

    const img = new Image()
    img.onload = () => { setIsLoading(false); }
    img.onerror = () => { setIsLoading(false); }
    img.src = currentBanner
  }, [currentBanner])

  const heroStyle = currentBanner && !isLoading ? {backgroundImage: `url(${currentBanner})`} : {}

  return (
    <div className={style.Hero} role='img' aria-label={`${title} banner`} style={heroStyle}>
      {isLoading && (
        <div className={style.SpinnerContainer}>
          <DotLottieReact
            src={spinnerLottie}
            autoplay
            loop
            className={style.Spinner}
            aria-label='Loading banner...'
            role='progressbar'
          />
        </div>
      )}
    </div>
  )
}
